module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN402_1265432327.e84625b7.png";